const Carging = () => {
    return (
        <div className="h100b">
            <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )

}

export default Carging;